export type Coordinates = {
  lat: number;
  lng: number;
};

const deg2rad = (deg: number) => deg * (Math.PI / 180);

export const calculateDistance = (from: Coordinates, to: Coordinates, units: 'km' | 'mi' = 'mi'): number => {
  const radius = units === 'mi' ? 3958.8 : 6371;
  const dLat = deg2rad(to.lat - from.lat);
  const dLon = deg2rad(to.lng - from.lng);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(from.lat)) * Math.cos(deg2rad(to.lat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return radius * c;
};
